//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { validationMessage } from 'vuelidate-messages';

const formMessages = {
  // required: () => 'Required',
  required: function () {
    return this.$i18n.t('error.required');
  },
  // minLength: ({ $params }) => `Must be at least ${$params.minLength.min} characters.`,
  minLength: function ({ $params }) {
    return this.$i18n.t('error.must_be_at_lease_{count}_characters', { count: $params.minLength.min });
  },
  maxLength: function ({ $params }) {
    return this.$i18n.t('error.must_be_less_than_{count}_characters', { count: $params.maxLength.max });
  },
  email: function () {
    return this.$i18n.t('error.invalid_email_address');
  },
  sameAsPassword: function () {
    return this.$i18n.t('error.passwords_do_not_match');
  },
  containAlpha: function () {
    return this.$i18n.t('error.must_contain_alphabetic');
  },
  containNumber: function () {
    return this.$i18n.t('error.must_contain_numeric');
  },
  invalidNumber: function () {
    return this.$i18n.t('error.invalid_number');
  },
  invalidUrl: function () {
    return this.$i18n.t('error.invalid_url');
  },
};

export default {
  name: 'base-input-text',
  props: {
    id: String,
    label: String,
    value: {
      type: [String, Number],
      default: '',
    },
    v: {
      type: Object,
    },
    type: {
      type: String,
      default: 'text',
    },
    name: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
    },
    mask: {
      type: [String, Array],
      required: false,
      default: '',
    },
    showErrorMsg: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    noInvert: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isRequired() {
      return _.has(this.v, '$params.required');
    },
  },
  methods: {
    getValidationMessage: validationMessage(formMessages),
  },
};
